import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';

import ReactList from '../../common/components/ReactList';

import customer from '../../customer';
const {getActivePermissions, getUsePLUCode} = customer.selectors;

import search from '../../search';
const {SearchPanel} = search.components;

import {clearSearchResults, 
        getPetLabelList, 
        searchPetLabels, 
        selectCustomLabel, 
        selectPetLabel, 
        toggleSelectedPetType, 
        quickSaveLabelToSheet,
        hideLabelModal,
        disableLabelAdd,
        enableLabelAdd} from '../actions';

import {arePetLabelsValid, 
        getSearchPhrase, 
        getSearchResults, 
        getSelectedGridIndex, 
        getSelectedPetTypes, 
        getPetTypes,
        getActivePageSize,
        isLabelModalOpen,
        getEmptyLabels,
        isLabelAddEnabled
        } from '../selectors';

import BackButton from './BackButton';
import CustomDropdown from './CustomDropdown';
import PetLabelInfo from './PetLabelInfo';
import LabelAddedModal from './LabelAddedModal';

import * as permissions from '../../common/userPermissions';

class PetSearchPage extends React.Component {
  componentWillMount() {
    const labelAccess = this.props.activePermissions.find((permission) => {
      return permission === permissions.ACCESS_LABELS;
    });
    if(!labelAccess)
    {
      this.props.actions.push('/labels');
    } 
    else if(this.props.selectedGridIndex < 0) {
      this.props.actions.push('/labels');
    } else if(!this.props.petLabelsValid) {
      this.props.actions.getPetLabelList();
    }
    if(this.props.emptyLabels <= 0)
    {
      this.props.actions.clearSearchResults();
      this.props.actions.push("/labels");
    }
    this.props.actions.hideLabelModal();
    this.props.actions.enableLabelAdd();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.emptyLabels <= 0) {
      this.props.actions.hideLabelModal();
      this.props.actions.clearSearchResults();
      this.props.actions.push("/labels");
    }
  }

  handleFormSubmit = (values) => {
    this.props.actions.searchPetLabels(values.searchPhrase);
  }

  handleLabelSelected = (petLabel, price) => {
    this.props.actions.disableLabelAdd();
    this.props.actions.quickSaveLabelToSheet(this.props.activePageSize, petLabel, price,this.props.activePLU);
  }

  handleCustomLabel = (petType) => {
    this.props.actions.selectCustomLabel(petType);
    this.props.actions.push('/custom_label');
  }

  handleLabelModalClose = () => {
    this.props.actions.hideLabelModal();
    this.props.actions.enableLabelAdd();
  }

  renderItem = (index, key) => {
    return <PetLabelInfo key={key} petLabel={this.props.searchResults[index]} onSelected={this.handleLabelSelected} enabled={this.props.labelAddEnabled}/>;
  }

  render() {
    const {actions, petLabelsValid, petTypeList, searchPhrase, searchResults, selectedPetTypes, isModalOpen} = this.props;

    return (
      <div id="wrapper"> 
        <div className="container-fluid main full-width" id="main">
            <div className="row">
                <div className="col-lg-12">
                  <h1 className="float-left">{I18n.t('CREATE_LABEL')}</h1>
                  <BackButton url="/labels"/>
                </div>
            </div>
            {!petLabelsValid && <div className="loading"/>}
            {petLabelsValid && <div><div className="row">
              <div className="col-lg-12">
                  
                <h3 className="float-left search-pets-title">{I18n.t('SEARCH_PETS')}</h3>
                <CustomDropdown petTypeList={petTypeList} onSelected={this.handleCustomLabel}/>

                <SearchPanel itemList={petTypeList}
                             onSelectedItem={actions.toggleSelectedPetType} 
                             onSubmit={this.handleFormSubmit}
                             selectedItems={selectedPetTypes}/>

                  

                {(searchResults.length === 0 && searchPhrase === '') && <div className="no-recent-labels">
                  <h1>{I18n.t('SEARCH_FOR_A_PET')}</h1><h3>{I18n.t('OR_CREATE_CUSTOM_LABEL')}</h3>
                </div>}
                
                {(searchResults.length === 0 && searchPhrase !== '') && <div className="no-recent-labels">
                    <h1>{I18n.t('NO_RESULTS_TRY_AGAIN')}</h1><h3>{I18n.t('OR_CREATE_CUSTOM_LABEL')}</h3>
                </div>}  


                {/*<h5>Recent</h5>*/}
                {searchResults.length > 0 && <h5>{I18n.t('RESULTS')} ({searchResults.length})</h5>}
              </div>
          </div>

          <div className="row search-results care-sheets">
            <ReactList itemRenderer={this.renderItem} length={searchResults.length} type="uniform"/>
          </div></div>}
        </div>
        <LabelAddedModal isOpen={isModalOpen} onClose={this.handleLabelModalClose}/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activePageSize: getActivePageSize(state),
    activePermissions: getActivePermissions(state),
    isModalOpen: isLabelModalOpen(state),
    petLabelsValid: arePetLabelsValid(state),
    petTypeList: getPetTypes(state),
    searchPhrase: getSearchPhrase(state),
    searchResults: getSearchResults(state),
    selectedGridIndex: getSelectedGridIndex(state),
    selectedPetTypes: getSelectedPetTypes(state),
    emptyLabels: getEmptyLabels(state),
    labelAddEnabled: isLabelAddEnabled(state),
    activePLU: getUsePLUCode(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({clearSearchResults, 
                                 getPetLabelList, 
                                 push, 
                                 searchPetLabels, 
                                 selectCustomLabel, 
                                 selectPetLabel, 
                                 toggleSelectedPetType,
                                 quickSaveLabelToSheet,
                                 hideLabelModal,
                                 disableLabelAdd,
                                 enableLabelAdd}, dispatch)
  };
}

PetSearchPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activePageSize: PropTypes.string.isRequired,
  activePermissions: PropTypes.array.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  petLabelsValid: PropTypes.bool.isRequired,
  petTypeList: PropTypes.array.isRequired,
  searchPhrase: PropTypes.string,
  searchResults: PropTypes.array.isRequired,
  selectedGridIndex: PropTypes.number.isRequired,
  selectedPetTypes: PropTypes.array.isRequired,
  emptyLabels: PropTypes.number.isRequired,
  labelAddEnabled: PropTypes.bool.isRequired,
  activePLU: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(PetSearchPage);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/PetSearchPage.js
 **/